import { lazy, useEffect, useState } from "react";
import { SC_KEY } from "../utils/constants/Constant_API";

function RouterDashboard() {
    const [modules, setModules] = useState<any>([])
    var CryptoJS = require("crypto-js");
    var bytesMS = CryptoJS.AES.decrypt(localStorage.getItem('React.LC.KY.MS'), SC_KEY);
    var userRoutes = JSON.parse(bytesMS.toString(CryptoJS.enc.Utf8));
    //console.log('User Routes: ',userRoutes)
    
    useEffect(() => {
        const fillRouter = async () => {
            let modules = await userRoutes.modules;

            let MapRoutes = modules.map((item: any) => {
                let father = item.modules;
                let childs = item.modules.flatMap((objeto: { modules: any[]; }) => objeto.modules);
                let family = father.concat(childs);
                let modulo = family.map((module: any) => {
                    return (
                        {
                            id: module.namesection!,
                            name: module.namesection!,
                            url: module.url!,
                            icon: module.icon!,
                            component: lazy(() => import(`../${module.component!}`)),
                            title: 'CMS Menah-' + `${module.namesection!}`
                        }
                    )
                });
                return (
                    {
                        section: item.namesection,
                        screens: modulo,
                    }
                )
            });
            setModules(MapRoutes);
        };
        fillRouter();
    }, []);

    return (modules);
}

export default RouterDashboard;